
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"20","viewBox":"0 0 46 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.4 19.695h-4.128l-9.073-15.26a1.185 1.185 0 00-1.018-.58H29.39c-.418 0-.805.221-1.018.58l-8.384 14.1a2.369 2.369 0 01-2.036 1.159h-4.479a2.37 2.37 0 01-2.036-1.159L.6.305h4.128l9.073 15.261c.213.359.6.58 1.018.58h1.79c.416 0 .801-.218 1.016-.574l8.387-14.106A2.369 2.369 0 0128.048.308h4.479c.834 0 1.608.44 2.035 1.158l10.84 18.23-.002-.001zm-9.22-5.92v-.096c-5.209 0-5.825-.616-5.825-5.825h-.19c0 5.21-.616 5.825-5.825 5.825v.191c5.209 0 5.825.616 5.825 5.825h.19c0-5.21.616-5.825 5.825-5.825v-.096z","fill":"#fff"}})])
          )
        }
      }
    